<template>
  <v-container fluid>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="8" md="6" class="text-center">
        <h1>Inicio</h1>
        <p>Bienvenido Al Sistema De Credencialización.</p>
        <!-- Botón de acceso directo -->
        <v-btn color="primary" @click="goToAdmin" class="mt-4">
          Ir a Administración
          <v-icon right>mdi-cog</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
  methods: {
    goToAdmin () {
      this.$router.push({ name: 'TreeView' }) // Nombre de la ruta definida en router.js
    }
  }
}
</script>

<style scoped>
h1 {
  color: #1976d2;
  font-weight: bold;
}
</style>
